/* eslint-disable no-empty-pattern */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    isInitialLoading: true,
    snapshotIsProcessing: true,
    paymentDocs: [],
    // latestPaymentId: '',
  },
  getters: {},
  mutations: {
    RESET_STATE(state) {
      state.isInitialLoading = true;
      state.snapshotIsProcessing = true;
      state.paymentDocs = [];
      state.latestPaymentId = '';
    },
    SET_IS_INITIAL_LOADING(state, isInitialLoading) {
      state.isInitialLoading = isInitialLoading;
    },
    SET_SNAPSHOT_IS_PROCESSING(state, snapshotIsProcessing) {
      state.snapshotIsProcessing = snapshotIsProcessing;
    },
    ADD_PAYMENT_DOCS(state, docs) {
      docs.forEach((doc) => {
        state.paymentDocs.splice(doc.index, 0, doc.data);
      });
    },
    MOVE_PAYMENT_DOC(state, { oldIndex, newIndex }) {
      // Move index in array
      state.paymentDocs.splice(newIndex, 0, state.paymentDocs.splice(oldIndex, 1)[0]);
    },
    SET_PAYMENT_DOC_FIELDS(state, { index, fields }) {
      if (!state.paymentDocs[index]) return;

      Vue.set(state.paymentDocs[index], 'fields', fields);
    },
    REMOVE_PAYMENT_DOC_INDEXES(state, docIndexes) {
      docIndexes.forEach((docIndex) => {
        state.paymentDocs.splice(docIndex, 1);
      });
    },
    // SET_LATEST_PAYMENT_ID(state, latestPaymentId) {
    //   state.latestPaymentId = latestPaymentId;
    // },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    updateIsInitialLoading({ commit }, isInitialLoading) {
      commit('SET_IS_INITIAL_LOADING', isInitialLoading);
    },
    async onSnapshot({ state, commit, dispatch }, snapshot) {
      commit('SET_SNAPSHOT_IS_PROCESSING', true);

      const docAdds = [];
      const docIndexesToDelete = [];
      const snapshotChangeTasks = [];

      snapshot.docChanges().forEach((snapshotChanges) => {
        if (snapshotChanges.type === 'added') {
          docAdds.push({
            index: snapshotChanges.newIndex,
            data: {
              id: snapshotChanges.doc.id,
              fields: snapshotChanges.doc.data(),
            },
          });
        } else if (snapshotChanges.type === 'modified') {
          snapshotChangeTasks.push(dispatch('modifyPaymentDoc', {
            oldIndex: snapshotChanges.oldIndex,
            newIndex: snapshotChanges.newIndex,
            fields: snapshotChanges.doc.data(),
          }));
        } else if (snapshotChanges.type === 'removed') {
          docIndexesToDelete.push(snapshotChanges.oldIndex);
        }
      });

      if (docAdds.length) {
        snapshotChangeTasks.push(dispatch('addPaymentDocs', docAdds));
      }
      if (docIndexesToDelete.length) {
        snapshotChangeTasks.push(dispatch('removePaymentDocIndexes', docIndexesToDelete));
      }

      await Promise.all(snapshotChangeTasks);

      commit('SET_SNAPSHOT_IS_PROCESSING', false);

      if (state.isInitialLoading) commit('SET_IS_INITIAL_LOADING', false);
    },
    addPaymentDocs({ commit }, docs) {
      commit('ADD_PAYMENT_DOCS', docs);
    },
    modifyPaymentDoc({ commit }, { oldIndex, newIndex, fields }) {
      if (oldIndex !== newIndex) commit('MOVE_PAYMENT_DOC', { oldIndex, newIndex });

      commit('SET_PAYMENT_DOC_FIELDS', { index: newIndex, fields });
    },
    removePaymentDocIndexes({ commit }, docIndexes) {
      commit('REMOVE_PAYMENT_DOC_INDEXES', docIndexes);
    },
    // updateLatestPaymentId({ commit }, latestPaymentId) {
    //   commit('SET_LATEST_PAYMENT_ID', latestPaymentId);
    // },
  },
};
